import { Navigate, Route, Routes } from 'react-router';
import Login from '../containers/Login';
import SignUp from '../containers/SignUp';
import ConsentToPersonalDataProcessing from '../components/ConsentToPersonalDataProcessing';
import SignUpSuccessPage from '../components/SignUpSuccessPage';
import PasswordRestore from '../containers/PasswordRestore';
import RestoreSuccessPage from '../components/RestoreSuccessPage';
import ChangePasswordAfterRestorePage from '../containers/ChangePasswordAfterRestorePage';
import AllVacanciesPage from '../containers/AllVacanciesPage';
import VacancyPage from '../containers/VacancyPage';
import AccountActivationRequestAlert from '../containers/AccountActivationRequestAlert';
import AccountActivationSuccess from '../containers/AccountActivationSuccess';


const PublicRoutes = () => (
  <div className="container-fluid p-0">
    <Routes>
      <Route path="/all-vacancies" element={<AllVacanciesPage />} />
      <Route path="/all-vacancies/:id" element={<VacancyPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/login/act" element={<AccountActivationRequestAlert />} />
      <Route path="/login/act/success" element={<AccountActivationSuccess />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/signup/act" element={<AccountActivationRequestAlert />} />
      <Route path="/signup/act/success" element={<AccountActivationSuccess />} />
      <Route path="/signup/success" element={<SignUpSuccessPage />} />
      <Route path="/contest-to-personal-data-processing" element={<ConsentToPersonalDataProcessing />} />
      <Route path="/restore" element={<PasswordRestore />} />
      <Route path="/restore/success" element={<RestoreSuccessPage />} />
      <Route path="/password/reset/:uid/:token" element={<ChangePasswordAfterRestorePage />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </div>
);

export default PublicRoutes;
